import { CheveronDownIcon } from '@wkda/icons';
import cx from 'classnames';
import { useState } from 'react';
import Paper from '../Paper';
import { ItemTitle } from '../VerticalNavMenu';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export default function NavMenu({
  dropdowns,
  LinkComponent = 'a',
  className,
  title: _title = '',
  ...spreadProps
}) {
  const [openedIndexes, setOpenedIndexes] = useState(null);
  function toggleDropDown(itemIndex) {
    setOpenedIndexes(prevIndex => {
      if (prevIndex === itemIndex) {
        return null;
      }
      return itemIndex;
    });
  }
  const lastDropDownItem = dropdowns[dropdowns.length - 1];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Paper, {
      isElevated: true,
      isFixedTop: true,
      className: cx('wa-nav', className),
      ...spreadProps,
      children: dropdowns.map(function (dropDown, index) {
        return /*#__PURE__*/_jsx(NavListItems, {
          title: dropDown.title !== '' ? /*#__PURE__*/_jsx(ItemTitle, {
            ...dropDown
          }) : null,
          items: dropDown.items,
          LinkComponent: LinkComponent,
          isOpened: openedIndexes === index,
          onTitleClick: () => {
            toggleDropDown(index);
          }
        }, index);
      })
    }), lastDropDownItem?.id === 'invisible' && /*#__PURE__*/_jsx("div", {
      style: {
        height: '40px'
      }
    })]
  });
}
function NavListItems({
  title,
  mobileTitle,
  items,
  LinkComponent,
  isOpened,
  onTitleClick
}) {
  const listTitle = title ? /*#__PURE__*/_jsx(ItemTitle, {
    title: title,
    mobileTitle: mobileTitle
  }) : null;
  return /*#__PURE__*/_jsxs("ul", {
    className: "wa-nav__list",
    children: [listTitle && /*#__PURE__*/_jsx("li", {
      className: cx('wa-nav__list-item', {
        'wa-nav__list-item--open': isOpened
      }),
      children: /*#__PURE__*/_jsxs("button", {
        className: "wa-nav__list-item-link",
        onClick: () => onTitleClick(),
        children: [listTitle, /*#__PURE__*/_jsx(CheveronDownIcon, {
          className: cx('wa-nav__chevron', {
            'wa-nav__chevron--is-open': isOpened
          })
        })]
      })
    }), (!listTitle || isOpened) && items.map((item, key) => /*#__PURE__*/_jsx("li", {
      className: "wa-nav__list-item",
      children: /*#__PURE__*/_jsx(LinkComponent, {
        className: "wa-nav__list-item-link wa-nav__list-item-link--sub",
        href: item.link,
        children: /*#__PURE__*/_jsx(ItemTitle, {
          ...item
        })
      })
    }, key))]
  });
}